/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Proration_NoticeInputs */



/**
* | output |
* | --- |
* | "Adding a member will charge a prorated amount on your next invoice." |
*
* @param {Members_Add_Proration_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_proration_notice = /** @type {((inputs?: Members_Add_Proration_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Proration_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Hinzufügen eines Mitglieds wird ein anteiliger Betrag auf Ihrer nächsten Rechnung berechnet.")
	return /** @type {LocalizedString} */ ("Adding a member will charge a prorated amount on your next invoice.")
});